import hasAccessToThis from 'services/utilFunctions/hasAccessToThis'

type GetEventCss = (event: MData.Event, highContrast?: boolean) => string

const getEventCss: GetEventCss = (
  {
    cancelled,
    contactListData: { takenBy } = {},
    employeeId,
    hasSpecificRequirements,
    isAbsent,
    isExtraShift,
    isIrreplaceable,
    needsReplacement,
    isLate,
    isLeavingEarly,
    isOnTimeoff,
    isOvertime,
    isOnCall,
    noEmployeeAvailable,
    coveredOtherUnit,
    hasUnapprovedTimeoff
  },
  highContrast
) => {
  // Borders for specific attributes
  let borderColor = ''
  if (hasSpecificRequirements && hasAccessToThis('userManageSpecificRestrictions')) borderColor = ' merinio-scheduler-event-right-border-yellow'
  if (noEmployeeAvailable) borderColor = ' merinio-scheduler-event-right-border-yellow'
  if (isIrreplaceable) borderColor = ' merinio-scheduler-event-right-border-yellow'
  if (needsReplacement) borderColor = ' merinio-scheduler-event-right-border-green'
  if (isOvertime) borderColor = ' merinio-scheduler-event-right-border-red'
  if (isOnCall) borderColor = ' merinio-scheduler-event-right-border-blue'
  if (isExtraShift) borderColor = ' merinio-scheduler-event-right-border-red'
  if (coveredOtherUnit) borderColor = ' merinio-scheduler-event-right-border-yellow'

  // Event color depending on event status
  let eventColor = `merinio-scheduler-event-gray-light`
  // The user's has an issue that they do not have access
  const hasAnAttendanceRequestAndCantSeeIt = (isAbsent || isLate || isLeavingEarly) && !hasAccessToThis('manageAttendance')
  const hasATimeOffAndCantSeeIt = isOnTimeoff && !hasAccessToThis('manageTimeOff')
  const hasSomeRequirements = hasSpecificRequirements && !hasAccessToThis('userManageSpecificRestrictions')
  if (hasAnAttendanceRequestAndCantSeeIt || hasATimeOffAndCantSeeIt || hasSomeRequirements) eventColor = `merinio-scheduler-event-teal event-striped`

  if (takenBy) eventColor = `merinio-scheduler-event-green`
  if (cancelled) eventColor = `merinio-scheduler-event-gray-light`
  if (isLeavingEarly && hasAccessToThis('manageAttendance')) eventColor = `merinio-scheduler-event-yellow`
  if (isLate && hasAccessToThis('manageAttendance')) eventColor = `merinio-scheduler-event-yellow`
  if (isAbsent && hasAccessToThis('manageAttendance')) eventColor = `merinio-scheduler-event-red`
  if (isOnTimeoff && hasAccessToThis('manageTimeOff')) eventColor = `merinio-scheduler-event-purple`
  if (hasUnapprovedTimeoff && hasAccessToThis('manageTimeOff')) eventColor = `merinio-scheduler-event-purple event-striped`
  if (!employeeId) eventColor = `merinio-scheduler-event-gray-dark event-striped`

  return `${eventColor}${borderColor}${highContrast ? ' high-contrast' : ''}`
}

export default getEventCss
